import {metadaApi} from '@dms/api/base';

import {
  DeleteFastTrackIssueBasketItemRequest,
  DeleteFastTrackIssueBasketItemRequestSchema,
  DeleteFastTrackIssueBasketItemResponse,
  DeleteFastTrackIssueBasketItemResponseSchema,
  DeleteFastTrackIssueRequest,
  DeleteFastTrackIssueRequestSchema,
  DeleteFastTrackIssueResponse,
  DeleteFastTrackIssueResponseSchema,
  GetFastTrackBasketRequest,
  GetFastTrackBasketRequestSchema,
  GetFastTrackBasketResponse,
  GetFastTrackBasketResponseSchema,
  GetFastTrackIssueRequest,
  GetFastTrackIssueRequestSchema,
  GetFastTrackIssueResponse,
  GetFastTrackIssueResponseSchema,
  PatchFastTrackIssueBasketItemQuantityRequest,
  PatchFastTrackIssueBasketItemQuantityRequestSchema,
  PatchFastTrackIssueBasketItemQuantityResponse,
  PatchFastTrackIssueBasketItemQuantityResponseSchema,
  PatchFastTrackIssueRequest,
  PatchFastTrackIssueRequestSchema,
  PatchFastTrackIssueResponse,
  PatchFastTrackIssueResponseSchema,
  PostFastTrackIssueBasketAddRequest,
  PostFastTrackIssueBasketAddRequestSchema,
  PostFastTrackIssueBasketAddResponse,
  PostFastTrackIssueBasketAddResponseSchema,
  PostFastTrackIssueBasketCheckoutRequest,
  PostFastTrackIssueBasketCheckoutRequestSchema,
  PostFastTrackIssueBasketCheckoutResponse,
  PostFastTrackIssueBasketCheckoutResponseSchema,
  PostFastTrackIssueBasketDiscardRequest,
  PostFastTrackIssueBasketDiscardRequestSchema,
  PostFastTrackIssueBasketDiscardResponse,
  PostFastTrackIssueBasketDiscardResponseSchema,
  PostFastTrackIssueRequest,
  PostFastTrackIssueRequestSchema,
  PostFastTrackIssueResponse,
  PostFastTrackIssueResponseSchema,
  PostFastTrackItemCompleteRequest,
  PostFastTrackItemCompleteRequestSchema,
  PostFastTrackItemCompleteResponse,
  PostFastTrackItemCompleteResponseSchema,
} from './types';

export const metadaWarehouseFastTrackApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getFastTrackIssue: build.query<GetFastTrackIssueResponse, GetFastTrackIssueRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/fast-track/${queryArg.fastTrackId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'fastTrackIssues', id: queryArg.fastTrackId},
      ],
      extraOptions: {
        requestSchema: GetFastTrackIssueRequestSchema,
        responseSchema: GetFastTrackIssueResponseSchema,
      },
    }),
    postFastTrackIssue: build.mutation<PostFastTrackIssueResponse, PostFastTrackIssueRequest>({
      query: (queryArg) => ({
        url: 'warehouse/v1/fast-track',
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: ['fastTrackIssues'],
      extraOptions: {
        requestSchema: PostFastTrackIssueRequestSchema,
        responseSchema: PostFastTrackIssueResponseSchema,
      },
    }),
    patchFastTrackIssue: build.mutation<PatchFastTrackIssueResponse, PatchFastTrackIssueRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/fast-track/${queryArg.fastTrackId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'fastTrackIssues', id: queryArg.fastTrackId},
      ],
      extraOptions: {
        requestSchema: PatchFastTrackIssueRequestSchema,
        responseSchema: PatchFastTrackIssueResponseSchema,
      },
    }),
    deleteFastTrackIssue: build.mutation<DeleteFastTrackIssueResponse, DeleteFastTrackIssueRequest>(
      {
        query: (queryArg) => ({
          url: `warehouse/v1/fast-track/delete`,
          method: 'POST',
          body: queryArg,
          queryArg,
        }),
        invalidatesTags: ['fastTrackIssues'],
        extraOptions: {
          requestSchema: DeleteFastTrackIssueRequestSchema,
          responseSchema: DeleteFastTrackIssueResponseSchema,
        },
      }
    ),
    getFastTrackBasket: build.query<GetFastTrackBasketResponse, GetFastTrackBasketRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/fast-track/${queryArg.fastTrackId}/basket`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'fastTrackBasket', id: queryArg.fastTrackId},
      ],
      extraOptions: {
        requestSchema: GetFastTrackBasketRequestSchema,
        responseSchema: GetFastTrackBasketResponseSchema,
      },
    }),
    checkoutFastTrackBasket: build.mutation<
      PostFastTrackIssueBasketCheckoutResponse,
      PostFastTrackIssueBasketCheckoutRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/fast-track/${queryArg.fastTrackId}/basket/checkout`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: ['fastTrackBasket', 'headerDynamicActions'],
      extraOptions: {
        requestSchema: PostFastTrackIssueBasketCheckoutRequestSchema,
        responseSchema: PostFastTrackIssueBasketCheckoutResponseSchema,
      },
    }),
    deleteFastTrackBasketItem: build.mutation<
      DeleteFastTrackIssueBasketItemResponse,
      DeleteFastTrackIssueBasketItemRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/fast-track/${queryArg.fastTrackId}/item/delete`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['fastTrackBasket', 'headerDynamicActions'],
      extraOptions: {
        requestSchema: DeleteFastTrackIssueBasketItemRequestSchema,
        responseSchema: DeleteFastTrackIssueBasketItemResponseSchema,
      },
    }),
    discardFastTrackBasketItem: build.mutation<
      PostFastTrackIssueBasketDiscardResponse,
      PostFastTrackIssueBasketDiscardRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/fast-track/${queryArg.fastTrackId}/basket/discard`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: ['fastTrackBasket', 'headerDynamicActions'],
      extraOptions: {
        requestSchema: PostFastTrackIssueBasketDiscardRequestSchema,
        responseSchema: PostFastTrackIssueBasketDiscardResponseSchema,
      },
    }),
    addFastTrackBasketItem: build.mutation<
      PostFastTrackIssueBasketAddResponse,
      PostFastTrackIssueBasketAddRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/fast-track/${queryArg.fastTrackId}/basket/add`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['fastTrackBasket', 'headerDynamicActions'],
      extraOptions: {
        requestSchema: PostFastTrackIssueBasketAddRequestSchema,
        responseSchema: PostFastTrackIssueBasketAddResponseSchema,
      },
    }),
    changeFastTrackBasketItemQuantity: build.mutation<
      PatchFastTrackIssueBasketItemQuantityResponse,
      PatchFastTrackIssueBasketItemQuantityRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/fast-track/${queryArg.fastTrackId}/item/${queryArg.fastTrackItemId}/quantity`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: ['fastTrackBasket', 'headerDynamicActions'],
      extraOptions: {
        requestSchema: PatchFastTrackIssueBasketItemQuantityRequestSchema,
        responseSchema: PatchFastTrackIssueBasketItemQuantityResponseSchema,
      },
    }),
    completeFastTrackItem: build.mutation<
      PostFastTrackItemCompleteResponse,
      PostFastTrackItemCompleteRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/fast-track/${queryArg.fastTrackId}/item/complete`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: ['fastTrackBasket', 'fastTrackIssues', 'headerDynamicActions'],
      extraOptions: {
        requestSchema: PostFastTrackItemCompleteRequestSchema,
        responseSchema: PostFastTrackItemCompleteResponseSchema,
      },
    }),
  }),
});

export const {
  useGetFastTrackIssueQuery,
  usePostFastTrackIssueMutation,
  usePatchFastTrackIssueMutation,
  useDeleteFastTrackIssueMutation,
  useGetFastTrackBasketQuery,
  useCheckoutFastTrackBasketMutation,
  useDeleteFastTrackBasketItemMutation,
  useDiscardFastTrackBasketItemMutation,
  useAddFastTrackBasketItemMutation,
  useChangeFastTrackBasketItemQuantityMutation,
  useCompleteFastTrackItemMutation,
} = metadaWarehouseFastTrackApi;
